<template>
  <b-card
    class="profile-header mb-2"
    img-top
    alt="cover photo"
    body-class="p-0"
  >
    <!-- profile picture -->
    <b-row class="position-relative justify-content-between">
      <b-col lg="5" class="profile-img-container d-flex align-items-center">
        <img-cropper
          :loading.sync="changingLogo"
          @confirm="onCrop"
          :img="ngoLogo"
        />
        <!-- profile title -->
        <div class="profile-title ml-3">
          <h2 class="text-dark">
            {{ headerData.name_ar }}
          </h2>
          <span class="alert alert-info px-25"
            >{{ headerData.legalForm.name_ar }}
          </span>
         
          
          &nbsp; -
          <span> رقم قرار الإشهار : {{ headerData.decision_no }} </span>
          <p v-if="headerData.mergedNgoName" class="my-1">  دامجة {{ headerData.mergedNgoName }} معها  </p>
        </div>
        <!--/ profile title -->
      </b-col>

      <b-col cols="3" class="text-center">
        <div class="d-flex justify-content-end">
          <div class="d-flex flex-column mt-50 align-items-start">
            <template v-if="!headerData.completed_by_ngo">
              <div
                v-if="!feedbackContent || feedbackContent === ''"
                class="text-warning"
              >
                لم يتم اعتماد ملف المنظمة بعد
              </div>
              <div v-else class="text-danger font-weight-bold">
                <feather-icon icon="XIcon" class="mr-50" />
                تم رفض الاعتماد
              </div>
              <div class="d-flex mt-50">
                <span
                  v-b-tooltip.hover.v-danger.bottom
                  :title="confirmBtnTooltip"
                >
                  <loader-btn
                    v-can="{ slug: 'ngo-profile', action: 'O' }"
                    :disabled="profileScore.completion !== 100"
                    label="اعتماد"
                    variant="success"
                    size="sm"
                    icon="CheckSquareIcon"
                    loadingLabel="جارٍ المعالجة ...  "
                    :loading="confirmingInfo"
                    @click="onConfirmInfo(true)"
                  />
                </span>

                <b-button
                  v-can="{ slug: 'ngo-profile', action: 'O' }"
                  :disabled="!feedbackContent || feedbackContent === ''"
                  variant="warning"
                  class="ml-50"
                  size="sm"
                  @click="setModalVisibility(true)"
                >
                  <feather-icon icon="MessageSquareIcon" class="mr-50" />

                  ردود الوزارة
                </b-button>
              </div>
            </template>
            <template v-else>
              <div class="text-success">
                <feather-icon icon="CheckSquareIcon" class="mr-50" />
                تم اعتماد الملف الشخصي
              </div>
              <div class="d-flex mt-50">
                <loader-btn
                  v-can="{ slug: 'ngo-profile', action: 'O' }"
                  v-if="!headerData.completed_by_directorate"
                  label="الغاء الاعتماد"
                  variant="danger"
                  size="sm"
                  icon="XIcon"
                  loadingLabel="جارٍ المعالجة ...  "
                  :loading="confirmingInfo"
                  @click="onConfirmInfo(false)"
                />
                <!-- <b-button
                  v-if="
                    !(
                      headerData.completed_by_ngo &&
                      headerData.completed_by_directorate &&
                      headerData.completed_by_ministry
                    )
                  "
                  :disabled="!feedbackContent || feedbackContent === ''"
                  variant="warning"
                  class="ml-50"
                  size="sm"
                  @click="setModalVisibility(true)"
                >
                  <feather-icon icon="MessageSquareIcon" class="mr-50" />

                  ردود الوزارة</b-button
                > -->
              </div>
            </template>
          </div>
        </div>

        <!-- <profile-completion /> -->
      </b-col>
    </b-row>
    <!--/ profile picture -->

    <div class="profile-header-nav">
      <b-navbar toggleable="md" type="light">
        <b-navbar-toggle class="ml-1" target="nav-text-collapse">
          <feather-icon icon="AlignJustifyIcon" size="21" />
        </b-navbar-toggle>

        <b-collapse id="nav-text-collapse" is-nav>
          <b-tabs pills class="profile-tabs mt-1 mt-md-0" nav-class="mb-0">
            <template #tabs-start>
              <b-nav-item
                v-if="canNavigate(tab.slug)"
                v-for="(tab, index) in profileTabs"
                :key="index"
                class="font-weight-bold"
                :active="$route.path === tab.path"
                @click="navigate(tab, index)"
              >
                <feather-icon :icon="tab.icon" class="d-block align-middle" />

                <span
                  v-if="tab.label"
                  style="user-select: none; cursor: pointer; margin: 0px 8px"
                  class="d-none d-md-block"
                  >{{ tab.label }}
                </span>
              </b-nav-item>
            </template>
          </b-tabs>
        </b-collapse>
      </b-navbar>
    </div>

    <!--/ profile navbar -->
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BTabs,
  BTab,
  BNavItem,
  BButton,
  BRow,
  BCol,
  BModal,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import profileCompletion from "./ProfileCompletion.vue";
import imgCropper from "./img-cropper.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import ToastificationContent from "@/@core/components/toastification/ToastificationContent.vue";
import AuthHelpers from "@/utils/auth-helpers";
import LoaderBtn from "@/components/loader-btn.vue";

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BButton,
    BRow,
    BCol,
    BModal,
    BNavItem,
    BNavbar,
    BNavbarToggle,
    BCollapse,
    BImg,
    profileCompletion,
    imgCropper,
    LoaderBtn,
  },
  directives: {
    Ripple,

    "b-tooltip": VBTooltip,
  },
  props: {
    headerData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      logoModal: false,
      qrModal: false,
      activeTab: 0,
      logo: null,
      //me
      state :null,
      profileTabs: [
        {
          path: "/ngo-profile/",
          icon: "HomeIcon",
          slug: "ngo_home",
        },
        {
          label: "معلومات التأسيس",
          path: "/ngo-profile/creation-info",
          icon: "InfoIcon",
          slug: "ngo_creation_info",
        },

        {
          label: "التصنيفات و الخدمات",
          path: "/ngo-profile/ngo-services",
          icon: "PackageIcon",
          slug: "ngo_classifications",
        },
        {
          label: "الفروع والمكاتب",
          path: "/ngo-profile/branches-and-departments",
          icon: "GitBranchIcon",
          slug: "ngo_branches",
        },
        {
          label: "المراكز الخدمية",
          path: "/ngo-profile/service-centers",
          icon: "MapPinIcon",
          slug: "ngo_service_centres",
        },
        {
          label: "معلومات التواصل",
          path: "/ngo-profile/contact-info",
          icon: "PhoneCallIcon",
          slug: "ngo_contact_information",
        },
        {
          label: "الحسابات البنكية",
          path: "/ngo-profile/bank-accounts",
          icon: "ArchiveIcon",
          slug: "ngo_bank_accounts",
        },
      ],
    };
  },
  watch: {
    activeTab(val) {
      this.$emit("tabChange", val);
    },
  },
  computed: {
    ...mapGetters("NgoProfile", [
      "changingLogo",
      "confirmingInfo",
      "profileScore",
    ]),
    ...mapGetters("FeedbackModule", ["feedbackContent"]),

    ngoLogo() {
      return this.logo || this.headerData.logo;
    },
    confirmBtnTooltip() {
      return this.profileScore.completion < 100
        ? "ملف المنظمة غير مكتمل بعد"
        : "";
    },
  },
  mounted() {
    if (AuthHelpers.canAction("ngo-profile", "O"))
      this.fetchFeedbackContent("v2/ngo-feedback");
  },
  methods: {
    ...mapActions("FeedbackModule", ["fetchFeedbackContent"]),
    ...mapMutations("FeedbackModule", ["setModalVisibility"]),
    ...mapActions("NgoProfile", [
      "updateNgoLogo",
      "confirmInfo",
      "fetchNgoData",
    ]),
    canNavigate(slug) {
      return AuthHelpers.canNavigate(slug);
    },

    onConfirmInfo(status) {
      const message = status
        ? "هل أنت متأكد من اعتماد المعلومات ؟"
        : "هل أنت متأكد من إلغاء اعتماد المعلومات ؟";
      const title = status
        ? "تأكيد اعتماد المعلومات"
        : "تأكيد إلغاء اعتماد المعلومات";
      const variant = status ? "success" : "danger";

      this.$bvModal
        .msgBoxConfirm(message, {
          title: title,
          size: "sm",
          okVariant: variant,
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.confirmInfo(status)
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تمت العملية بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                    timeout: 3000,
                  },
                });
                this.fetchNgoData();
              })
              .catch(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "حدث خطأ أثناء تنفيذ العملية !",
                    icon: "XIcon",
                    variant: "danger",
                    timeout: 5000,
                  },
                });
              });
          }
        });
    },
    onCrop(canvas) {
      canvas.canvas.toBlob(async (blob) => {
        this.updateNgoLogo(blob)
          .then(() => {
            this.logo = URL.createObjectURL(blob);
            // this
          })
          .catch((err) => {
            if (err !== 403)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "حدث خطأ أثناء رفع الصورة",
                  text: "يرجى المحاولة مجدداً في وقت لاحق",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                },
              });
          });
      });
    },
    navigate(tab, index) {
      this.activeTab = index;
      this.$router.push(tab.path);
    },
  },
};
</script>

<style lang="scss">
.nav-link.active {
  transition: all 0.2s ease-in-out;
}

.nav-link {
  &:hover {
    opacity: 0.7;
    transition: all 0.2s ease-in-out;
  }
}
</style>
